<template>
  <div class="mylesson">
    <my-study-nav></my-study-nav>
    <div class="content-right">
      <h2 class="top-title">作业管理</h2>
      <section class="category-wrapper">
        <span class="tab-item" @click="changeTab(0)" :class="{'active':index===0}">
          未完结
        </span>
        <span class="tab-item" @click="changeTab(1)" :class="{'active':index===1}">
          已完结
        </span>
      </section>
      <template v-if="!isEmpty(orderList)">
        <div class="list-wrapper">
          <template v-if="!isEmpty(orderList)">
            <class-item :isComplete="isComplete" :id="id" :classinfo="item" v-for="(item,index) in orderList"
                        :key="index"></class-item>
          </template>
        </div>
        <template v-if="totoalPage>10">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :page-size="10"
            :total="totoalPage">
          </el-pagination>
        </template>
      </template>
      <div class="no-result" v-if="isEmpty(orderList)">
        <img src="./noresult.png" alt="没有结果" width="148" height="118">
        <a href="/" class="noresult-link">暂无作业</a>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import MyStudyNav from 'components/mystudynav/MyStudyNav'
  import classItem from './component/workitem'

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        //切换tab
        index: 0,
        currentPage: 1,
        totoalPage: 1,
        orderList: [],
        isComplete: false,
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      changeTab(iscomplete) {
        this.isComplete = !!iscomplete;
        this.index = iscomplete;
        this.orderList = [];
        this.currentPage = 1;
        this.QueryHomeWork(1, iscomplete);
        this.$forceUpdate();
      },
      //改变页码时
      handleCurrentChange(val) {
        this.QueryHomeWork(val, this.index);
        this.$forceUpdate();
      },
      QueryHomeWork(pageNumber, iscomplete) {
        this.orderList = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'HomeWork',
            a: 'QueryHomeWork',
            id: this.id,
            isstudent: 1,
            iscomplete: iscomplete,
            pageno: pageNumber,
            pagesize: 10,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
            return;
          }
          if (response.code === 200) {
            this.orderList = response.list;
            this.totoalPage = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {
        });
      }
    },
    created() {
      this.QueryHomeWork(1, 0);
    },
    components: {
      MyStudyNav,
      classItem
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .mylesson
    margin: 10px auto 40px
    width: 1226px
    min-height: calc(100vh - 385px)
    box-sizing border-box
    overflow: hidden
    .content-right
      float: right
      width: 966px
      .top-title {
        height: 68px
        line-height: 68px;
        padding-left: 20px;
        font-size: 24px;
        font-weight: bold
        color: #333;
        background: #fff;
      }
      .category-wrapper
        height: 45px
        padding-left: 40px
        background: #ffffff
        border-top: 1px solid #f5f5f5
        .tab-item
          margin-right: 80px
          float: left
          height: 45px
          line-height: 45px
          font-size: 18px
          color: #666666
          box-sizing: border-box
          cursor: pointer
          &.active
            color: #ff6700
            border-bottom: 2px solid #ff6700
      .no-result
        margin-top: 10px;
        padding-top: 200px
        height: 871px
        text-align: center
        box-sizing border-box
        font-size: 0
        background: #fff
        .noresult-link
          display: block
          margin-top: 20px
          font-size: 16px
          color: #888888
          text-decoration underline
      .list-wrapper
        overflow hidden
        font-size: 0
        margin-top: 10px;
</style>



// WEBPACK FOOTER //
// src/page/account/personal/work/work.vue